module.exports = __webpack_public_path__ + "img/ms-dagger.5d09306a.svg";